var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.656,
    height: 30.787,
    viewBox: "0 0 25.656 30.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162750",
    "data-name": "Group 162750",
    transform: "translate(-833 -1119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M115.143,119.42l-5.131-5.131-5.131,5.131-5.131,5.131,5.131,5.131,5.131-5.131Z",
    transform: "translate(733.25 1004.711)",
    fill: "#00274c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M104.881,176.218l5.131,5.131,5.131-5.131-5.131-5.131-5.131-5.131-5.131,5.131Z",
    transform: "translate(733.25 968.438)",
    fill: "#00274c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 7.256,
    height: 7.256,
    transform: "translate(848.394 1134.394) rotate(-45)",
    fill: "#00274c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNav);
export default __webpack_public_path__ + "static/media/logoNav.d08f853cc81644b3a3724ccfa43b1738.svg";
export { ForwardRef as ReactComponent };